/* Printora: Galerie, Farbwahl, Warenkorb mit Geschenkband-Regel, Video und Band-Vorschau */
(function () {
  const cfg = window.PRINTORA || {};
  const $ = id => document.getElementById(id);
  const page = $('page');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = cents => '€' + (Math.round(cents) / 100).toFixed(2);

  /* ---------- Hinweis ---------- */
  const toastEl = $('toast');
  let toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 3800);
  }

  /* ---------- Galerie ---------- */
  const mainImg = $('main-img');
  const count = $('gallery-count');
  const thumbs = Array.from(document.querySelectorAll('.thumb'));
  let current = Math.max(0, thumbs.findIndex(t => t.getAttribute('aria-current') === 'true'));
  function show(i) {
    if (!thumbs.length || !mainImg) return;
    current = (i + thumbs.length) % thumbs.length;
    mainImg.src = thumbs[current].dataset.src;
    mainImg.alt = thumbs[current].dataset.alt || '';
    if (count) count.textContent = (current + 1) + ' / ' + thumbs.length;
    thumbs.forEach((t, k) => t.setAttribute('aria-current', k === current ? 'true' : 'false'));
  }
  thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
  if ($('prev-img')) $('prev-img').addEventListener('click', () => show(current - 1));
  if ($('next-img')) $('next-img').addEventListener('click', () => show(current + 1));

  /* ---------- Farbwahl und Preis ---------- */
  const addBtn = $('add-btn');
  const addonCheck = $('addon-check');
  const addonColor = $('addon-color');
  const printerVariants = (cfg.printer && cfg.printer.variants) || [];
  const ribbonVariants = (cfg.ribbon && cfg.ribbon.variants) || [];
  let qty = 1;

  function printerPrice() {
    const id = addBtn ? Number(addBtn.dataset.variantId) : 0;
    const v = printerVariants.find(x => x.id === id) || printerVariants[0];
    return v ? v.price : 0;
  }
  function ribbonPrice(id) {
    const v = ribbonVariants.find(x => x.id === Number(id)) || ribbonVariants[0];
    return v ? v.price : 0;
  }
  function updateSum() {
    if ($('qty')) $('qty').textContent = qty;
    if ($('sum')) $('sum').textContent = fmt(printerPrice() * qty + (addonCheck && addonCheck.checked ? ribbonPrice(addonColor.value) : 0));
  }

  document.querySelectorAll('.swatch').forEach(sw => {
    sw.addEventListener('click', () => {
      page.dataset.variant = sw.dataset.variant;
      document.querySelectorAll('.swatch').forEach(s => s.setAttribute('aria-checked', s === sw ? 'true' : 'false'));
      if ($('variant-name')) $('variant-name').textContent = sw.dataset.title;
      if (addBtn) addBtn.dataset.variantId = sw.dataset.variantId;
      const k = thumbs.findIndex(t => t.dataset.imageId && t.dataset.imageId === sw.dataset.imageId);
      if (k >= 0) show(k);
      const cta = $('cta-img');
      if (cta && sw.dataset.image) { cta.src = sw.dataset.image; cta.alt = 'Printora Label Printer in ' + sw.dataset.title; }
      updateSum();
    });
  });
  if ($('qty-minus')) $('qty-minus').addEventListener('click', () => { qty = Math.max(1, qty - 1); updateSum(); });
  if ($('qty-plus')) $('qty-plus').addEventListener('click', () => { qty = Math.min(9, qty + 1); updateSum(); });
  if (addonCheck) addonCheck.addEventListener('change', () => { addonColor.disabled = !addonCheck.checked; updateSum(); });
  if (addonColor) addonColor.addEventListener('change', updateSum);

  /* ---------- Warenkorb: Printer groß, alle Bandfarben zum Antippen darunter ---------- */
  const drawer = $('drawer');
  const backdrop = $('drawer-backdrop');
  const itemsEl = $('drawer-items');
  const pickerEl = $('ribbon-picker');
  const checkoutBtn = $('checkout-btn');
  let cart = { items: [], item_count: 0, total_price: 0 };

  async function request(url, body) {
    const res = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }
  async function refreshCart() {
    cart = await request(cfg.routes.cart);
    renderCart();
    return cart;
  }

  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const shortName = t => t.replace(' with gold lettering', ' · gold').replace(' with black lettering', ' · black');

  function stepper(value, onMinus, onPlus, label) {
    const q = document.createElement('div');
    q.className = 'line-qty';
    const minus = document.createElement('button');
    minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'One less' + (label ? ': ' + label : ''));
    minus.disabled = value <= 0;
    const n = document.createElement('span');
    n.textContent = value;
    const plus = document.createElement('button');
    plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'One more' + (label ? ': ' + label : ''));
    minus.addEventListener('click', onMinus);
    plus.addEventListener('click', onPlus);
    q.append(minus, n, plus);
    return q;
  }

  function renderCart() {
    if ($('cart-count')) $('cart-count').textContent = cart.item_count;
    if (itemsEl) {
      itemsEl.innerHTML = '';
      const main = cart.items.filter(i => i.handle !== 'gift-ribbon');
      if (!main.length) {
        const li = document.createElement('li');
        li.className = 'drawer-empty';
        li.textContent = cart.items.length ? 'Your ribbons are below. The Label Printer is on the page above.' : 'Your cart is empty.';
        itemsEl.appendChild(li);
      }
      main.forEach(item => {
        const hero = item.handle === 'label-printer';
        const li = document.createElement('li');
        if (hero) li.className = 'line-hero';
        const img = document.createElement('img');
        img.src = sized(item.image, hero ? 240 : 128);
        img.alt = '';
        img.width = img.height = hero ? 112 : 64;
        const info = document.createElement('div');
        const name = document.createElement('b');
        name.textContent = hero ? 'Label Printer' : item.product_title;
        const sub = document.createElement('small');
        sub.textContent = item.variant_title || '';
        const q = stepper(item.quantity, () => changeLine(item.key, item.quantity - 1), () => changeLine(item.key, item.quantity + 1), name.textContent);
        const price = document.createElement('span');
        price.className = 'line-price';
        price.textContent = fmt(item.final_line_price);
        if (hero) {
          const meta = document.createElement('div');
          meta.className = 'line-meta';
          meta.append(q, price);
          info.append(name, sub, meta);
          li.append(img, info);
        } else {
          info.append(name, sub, q);
          li.append(img, info, price);
        }
        itemsEl.appendChild(li);
      });
    }
    renderPicker();
    if ($('cart-total')) $('cart-total').textContent = fmt(cart.total_price);
    if (checkoutBtn) checkoutBtn.disabled = !cart.items.length;
  }

  function renderPicker() {
    if (!pickerEl || !ribbonVariants.length) return;
    pickerEl.innerHTML = '';
    const fallback = cfg.ribbon && cfg.ribbon.featured_image;
    ribbonVariants.forEach(v => {
      const line = cart.items.find(i => i.variant_id === v.id);
      const inCart = line ? line.quantity : 0;
      const li = document.createElement('li');
      li.className = 'pick' + (inCart ? ' is-picked' : '');
      const img = document.createElement('img');
      img.src = sized((v.featured_image && v.featured_image.src) || fallback, 120);
      img.alt = '';
      img.width = img.height = 44;
      const name = document.createElement('span');
      name.className = 'pick-name';
      name.textContent = shortName(v.title);
      const q = stepper(inCart,
        () => { if (line) changeLine(line.key, inCart - 1); },
        () => { if (line) changeLine(line.key, inCart + 1); else addItems([{ id: v.id, quantity: 1 }]); },
        shortName(v.title));
      li.append(img, name, q);
      pickerEl.appendChild(li);
    });
  }

  async function changeLine(key, quantity) {
    if (drawer) drawer.classList.add('is-busy');
    try { cart = await request(cfg.routes.cartChange, { id: key, quantity: Math.max(0, quantity) }); renderCart(); }
    catch (e) { toast(e.message); }
    finally { if (drawer) drawer.classList.remove('is-busy'); }
  }
  async function addItems(items, button) {
    if (button) button.classList.add('is-busy');
    if (drawer) drawer.classList.add('is-busy');
    try { await request(cfg.routes.cartAdd, { items }); await refreshCart(); openCart(); }
    catch (e) { toast(e.message); }
    finally { if (button) button.classList.remove('is-busy'); if (drawer) drawer.classList.remove('is-busy'); }
  }

  function openCart() {
    if (!drawer || drawer.classList.contains('open')) return;
    drawer.inert = false;
    drawer.classList.add('open');
    backdrop.classList.add('open');
    $('drawer-close').focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    backdrop.classList.remove('open');
    drawer.inert = true;
  }
  if ($('drawer-close')) $('drawer-close').addEventListener('click', closeCart);
  if (backdrop) backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  if ($('cart-btn') && drawer) {
    $('cart-btn').addEventListener('click', e => { e.preventDefault(); refreshCart().catch(() => {}); openCart(); });
  }
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => { if (cart.items.length) window.location.href = cfg.routes.checkout; });
  }

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      const items = [{ id: Number(addBtn.dataset.variantId), quantity: qty }];
      if (addonCheck && addonCheck.checked) items.push({ id: Number(addonColor.value), quantity: 1 });
      addItems(items, addBtn);
    });
  }
  if ($('cta-add')) {
    $('cta-add').addEventListener('click', () => { if (addBtn) addBtn.click(); else window.location.href = '/#kaufen'; });
  }

  /* ---------- Seite des Geschenkbands ---------- */
  const ribbonAdd = $('ribbon-add');
  if (ribbonAdd) {
    const sel = $('ribbon-color');
    let rq = 1;
    const sync = () => {
      $('ribbon-qty').textContent = rq;
      $('ribbon-sum').textContent = fmt(ribbonPrice(sel.value) * rq);
      const opt = sel.options[sel.selectedIndex];
      if (opt && opt.dataset.image) $('ribbon-img').src = opt.dataset.image;
    };
    $('ribbon-minus').addEventListener('click', () => { rq = Math.max(1, rq - 1); sync(); });
    $('ribbon-plus').addEventListener('click', () => { rq = Math.min(99, rq + 1); sync(); });
    sel.addEventListener('change', sync);
    ribbonAdd.addEventListener('click', () => addItems([{ id: Number(sel.value), quantity: rq }], ribbonAdd));
  }

  /* ---------- Video ---------- */
  const film = $('film');
  if (film) {
    const playBtn = $('film-play');
    const soundBtn = $('film-sound');
    const syncPlay = () => { playBtn.textContent = film.paused ? 'Play' : 'Pause'; };
    if (reduce) { film.removeAttribute('autoplay'); film.pause(); }
    film.addEventListener('play', syncPlay);
    film.addEventListener('pause', syncPlay);
    syncPlay();
    playBtn.addEventListener('click', () => { if (film.paused) film.play().catch(() => {}); else film.pause(); });
    soundBtn.addEventListener('click', () => {
      film.muted = !film.muted;
      soundBtn.textContent = film.muted ? 'Sound on' : 'Sound off';
      if (!film.muted && film.paused) film.play().catch(() => {});
    });
  }

  /* ---------- Band-Vorschau ---------- */
  const preview = $('rb-preview');
  if (preview) {
    const colours = {
      kleberolle: { name: 'White adhesive roll', bg: '#FFFFFF', fg: '#1E1A18', label: true },
      rot: { name: 'Red · gold', bg: '#A3161E', fg: '#DDB65B' },
      dunkelblau: { name: 'Navy · gold', bg: '#1F2A4D', fg: '#DDB65B' },
      weiss: { name: 'White · gold', bg: '#F6F3EC', fg: '#B08A36' },
      creme: { name: 'Cream · black', bg: '#E9DCC4', fg: '#1E1A18' },
      rosa: { name: 'Pink · black', bg: '#EEC3CA', fg: '#1E1A18' },
      hellblau: { name: 'Light blue · black', bg: '#BCD4E7', fg: '#1E1A18' }
    };
    const order = ['kleberolle', 'rot', 'dunkelblau', 'weiss', 'creme', 'rosa', 'hellblau'];
    const SYMBOLS = {
      '♥': '<path d="M12 21s-7.4-4.6-9.5-9.1C1 8.4 3 4.5 6.7 4.5c2.1 0 3.6 1.2 4.3 2.6.7-1.4 2.2-2.6 4.3-2.6 3.7 0 5.7 3.9 4.2 7.4C19.4 16.4 12 21 12 21z"/>',
      '★': '<path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/>',
      '✿': '<circle cx="12" cy="6.2" r="4"/><circle cx="17.8" cy="10.4" r="4"/><circle cx="15.6" cy="17.2" r="4"/><circle cx="8.4" cy="17.2" r="4"/><circle cx="6.2" cy="10.4" r="4"/><circle cx="12" cy="12.2" r="2.4" style="fill: var(--rb)"/>'
    };
    const state = { band: 'rot', font: 'ribbon', sym: '♥' };
    const out = $('rb-out');
    const textIn = $('rb-text');
    const bandWrap = $('rb-bands');
    const takeBtn = $('rb-take');

    function symbol(s) {
      const el = document.createElement('span');
      el.className = 'sym';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<svg viewBox="0 0 24 24">' + SYMBOLS[s] + '</svg>';
      return el;
    }
    order.forEach(key => {
      const b = colours[key];
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'chip';
      chip.setAttribute('role', 'radio');
      chip.dataset.band = key;
      chip.style.setProperty('--c', b.bg);
      chip.style.setProperty('--t', b.fg);
      chip.innerHTML = '<i aria-hidden="true"></i>';
      chip.appendChild(document.createTextNode(b.name));
      chip.addEventListener('click', () => { state.band = key; render(true); });
      bandWrap.appendChild(chip);
    });
    document.querySelectorAll('#rb-fonts button').forEach(btn => btn.addEventListener('click', () => { state.font = btn.dataset.font; render(true); }));
    document.querySelectorAll('#rb-syms button').forEach(btn => btn.addEventListener('click', () => { state.sym = btn.dataset.sym; render(true); }));
    textIn.addEventListener('input', () => render(true));

    function render(feed) {
      const b = colours[state.band];
      const text = textIn.value.trim() || 'Your text';
      out.replaceChildren(...(state.sym ? [symbol(state.sym), document.createTextNode(text), symbol(state.sym)] : [document.createTextNode(text)]));
      preview.style.setProperty('--rb', b.bg);
      preview.style.setProperty('--rt', b.fg);
      preview.classList.toggle('is-label', !!b.label);
      preview.classList.toggle('font-device', state.font === 'device');
      preview.classList.toggle('font-sans', state.font === 'sans');
      if (feed && !reduce) { preview.classList.remove('feeding'); void preview.offsetWidth; preview.classList.add('feeding'); }
      bandWrap.querySelectorAll('.chip').forEach(c => c.setAttribute('aria-checked', c.dataset.band === state.band ? 'true' : 'false'));
      document.querySelectorAll('#rb-fonts button').forEach(x => x.setAttribute('aria-checked', x.dataset.font === state.font ? 'true' : 'false'));
      document.querySelectorAll('#rb-syms button').forEach(x => x.setAttribute('aria-checked', x.dataset.sym === state.sym ? 'true' : 'false'));
      takeBtn.disabled = !!b.label;
      takeBtn.textContent = b.label ? 'The adhesive roll is already included' : 'Add this ribbon';
    }
    takeBtn.addEventListener('click', () => {
      if (colours[state.band].label || !addonColor) return;
      const opt = Array.from(addonColor.options).find(o => o.dataset.band === state.band);
      if (!opt) return;
      addonCheck.checked = true;
      addonColor.disabled = false;
      addonColor.value = opt.value;
      updateSum();
      $('kaufen').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      toast('Gift ribbon ' + opt.text + ' is now selected in the buy box.');
    });
    render(false);
  }

  updateSum();
  if (cfg.routes) refreshCart().catch(() => {});
})();
